import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class CropsApi extends ApiModule {
	constructor() {
		super(ModulesMap.CROPS, {
			entity: 'crops',
		})
	}
}
